// Module
var code = "<div> <section class=\"heading\"> <div class=\"row no-gutter\"> <ng-include src=\"'/dashboard/nav.html'\"></ng-include> </div> </section> <div class=\"row no-gutter\"> <proof-of-identity-files current-user=\"currentUser\" on-success=\"onSuccess\" on-error=\"onError\"/> </div> </div> ";
// Exports
var _module_exports = code;;
var path = '/dashboard/proof_of_identity_files.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;